<template>
  <div class="content-container">
    <search-component
      :is-room-condition="true"
      @onSearch="onSearch"
      @onReset="onReset"
    />
    <!-- Search Component -->
    <div v-loading="loading" class="grid-scroll">
      <GridVx
        ref="agGrid"
        :columns="columns"
        :auto-select-first-row="false"
        :row-multi-select-with-click="true"
        dom-layout="scroll"
        :auto-size-cell="true"
        :rows="rows"
        class="agGrid"
        @selectionChanged="onRowSelected"
      />
    </div>
    <div class="flex justify-space-between">
      <div class="button-containers mb-0">
        <button
          class="btn primary small outline"
          @click="infoDialogVisible = true"
        >
          Chú thích
        </button>
      </div>
      <div class="button-containers">
        <!-- <button class="btn primary small" @click="dialogFormVisible = true">
          {{ $t('button.addService') }}
        </button> -->
        <button
          v-if="checkAuthorChangeRoomStt1"
          :disabled="isOOORoom || selectedRows.length === 0"
          class="btn primary small"
          @click="changeRoomCondition(1)"
        >
          {{ $t('button.dirty') }}
        </button>
        <button
          v-if="checkAuthorChangeRoomStt1"
          :disabled="isOOORoom || selectedRows.length === 0"
          class="btn primary small"
          @click="changeRoomCondition(2)"
        >
          {{ $t('button.clean') }}
        </button>
        <button
          v-if="checkAuthorRoomChecked"
          :disabled="isOOORoom || selectedRows.length === 0"
          class="btn primary small"
          @click="changeRoomCondition(4)"
        >
          {{ $t('button.checked') }}
        </button>
        <button
          v-if="checkAuthorChangeRoomStt2"
          :disabled="isOOORoom || selectedRows.length === 0"
          class="btn primary small"
          @click="changeRoomCondition(null, 0)"
        >
          {{ $t('button.empty') }}
        </button>
        <button
          v-if="checkAuthorChangeRoomStt2"
          :disabled="isOOORoom || selectedRows.length === 0"
          class="btn primary small"
          @click="changeRoomCondition(null, 1)"
        >
          {{ $t('button.occupied') }}
        </button>
      </div>
    </div>
    <!-- <el-dialog
      :title="
        isEdit
          ? $t('dialog.titleroomConditionEdit')
          : $t('dialog.titleroomConditionAdd')
      "
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
      width="700px"
    >
      <div class="das-form-container">
        <div class="das-form-group">
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label required">Ngày yêu cầu</div>
                <SingleCalendar class="use-icon" />
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label required">Yêu cầu bởi</div>
                <input type="text" />
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label required">Ưu tiên</div>
                <input type="text" />
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label required">Loại việc</div>
                <input type="text" />
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label required">Khu vực bảo trì</div>
                <input type="text" />
              </div>
            </div>
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label required">Phòng</div>
                <input type="text" />
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-4">
              <div class="das-form-input">
                <div class="label required">Vị trí bảo trì</div>
                <input type="text" />
              </div>
            </div>
            <div class="das-form-col col-8">
              <div class="das-form-input">
                <div class="label required">Tác vụ đi kèm</div>
                <div class="checkbox-container">
                  <div class="checkbox-wrap">
                    <input id="cpSpdTp3" type="checkbox" />
                    <label for="cpSpdTp3">Không có</label>
                  </div>
                  <div class="checkbox-wrap">
                    <input id="cpSpdTp3" type="checkbox" />
                    <label for="cpSpdTp3">Tạo OOO</label>
                  </div>
                  <div class="checkbox-wrap">
                    <input id="cpSpdTp3" type="checkbox" />
                    <label for="cpSpdTp3">Tạo OOS</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="das-form-row">
            <div class="das-form-col col-12">
              <div class="das-form-input">
                <div class="label required">Mô tả công việc</div>
                <textarea style="width: 100%" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="dialogFormVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
          <button class="btn primary small" @click="addHkStatus">
            {{ $t('button.add') }}
          </button>
        </div>
      </span>
    </el-dialog> -->
    <el-dialog
      title="Chú thích"
      :visible.sync="infoDialogVisible"
      :close-on-click-modal="false"
      width="600px"
    >
      <div style="height: 325px">
        <GridVx
          :columns="infoCols"
          :auto-size-cell="true"
          dom-layout="scroll"
          :rows="infoRows"
          class="agGridInfo"
        />
      </div>

      <span slot="footer" class="dialog-footer">
        <div class="button-containers">
          <button
            class="btn primary small outline"
            @click="infoDialogVisible = false"
          >
            {{ $t('button.cancel') }}
          </button>
        </div>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// import SingleCalendar from '@/components/ui/SingleCalendar.vue'
import {
  getListHouseKeepingApi,
  changeStatusHouseKeepingApi
} from '@/api/houseKeeper/house-keeping-mng.js'
import SearchComponent from './components/taskAssignmentSearchComponent.vue'
import { checkAuthorized } from '@/utils/helper'
export default {
  components: {
    // SingleCalendar
    SearchComponent
  },
  data() {
    return {
      // author
      checkAuthorRoomChecked: false,
      checkAuthorChangeRoomStt1: false,
      checkAuthorChangeRoomStt2: false,
      selectedRows: [],
      isOOORoom: false,
      infoDialogVisible: false,
      isEdit: false,
      loading: false,
      searchParams: {
        hotel_ids: [],
        diff: [],
        drif: null
      },
      roomOptions: [],
      // dialogFormVisible: false,
      infoCols: [
        {
          headerName: 'Loại',
          field: 'type',
          maxWidth: 150,
          cellStyle: params => {
            const data = params.data.type
            const property = {
              fontWeight: 'bold',
              color: 'white',
              backgroundColor: null
            }
            if (data === 'VCI' || data === 'OCI') {
              // checked
              property.backgroundColor = '#c3edd9'
              property.color = '#357456'
            } else if (data === 'VD' || data === 'OD') {
              // dirty
              property.backgroundColor = '#ffdfe1'
              property.color = '#f12b37'
            } else if (data === 'OOS' || data === 'OOO') {
              property.backgroundColor = '#cdcccc'
              property.color = '#575757'
            } else if (
              data === 'Sleep' ||
              data === 'Skip' ||
              data === 'People'
            ) {
              property.backgroundColor = '#fff'
              property.color = '#000'
            } else {
              // clean
              property.backgroundColor = '#ffecd5'
              property.color = '#ea7e00'
            }
            return property
          }
        },
        {
          headerName: 'Nội dung',
          field: 'content'
        }
      ],
      infoRows: [
        {
          type: 'OC',
          content: 'Phòng có khách, sạch'
        },
        {
          type: 'OD',
          content: 'Phòng có khách, bẩn'
        },
        {
          type: 'OCI',
          content: 'Phòng có khách, sạch, đã kiểm tra'
        },
        {
          type: 'VC',
          content: 'Phòng trống khách, sạch'
        },
        {
          type: 'VD',
          content: 'Phòng trống khách, bẩn'
        },
        {
          type: 'VCI',
          content: 'Phòng trống khách, sạch, đã kiểm tra'
        },
        {
          type: 'OOO',
          content: 'Phòng ngừng sử dụng'
        },
        {
          type: 'OOS',
          content: 'Phòng không phục vụ'
        },
        {
          type: 'Sleep',
          content: 'Buồng có khách, lễ tân trống khách'
        },
        {
          type: 'Skip',
          content: 'Lễ tân có khách, buồng trống khách'
        },
        {
          type: 'People',
          content: 'Số lượng khách giữa buồng và lễ tân khác nhau'
        }
      ],
      columns: [
        {
          headerName: '',
          field: 'index',
          minWidth: 60,
          maxWidth: 60,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          checkboxSelection: true,
          resizable: false
        },

        {
          headerName: this.$t('grid.column.room'),
          field: 'room_num'
        },
        {
          headerName: this.$t('grid.column.roomStatus'),
          field: 'room_status',
          cellStyle: params => {
            const data = params.data.room_status
            const property = {
              fontWeight: 'bold',
              color: 'white',
              backgroundColor: null
            }
            if (data === 'VCI' || data === 'OCI') {
              // checked
              property.backgroundColor = '#c3edd9'
              property.color = '#357456'
            } else if (data === 'VD' || data === 'OD') {
              // dirty
              property.backgroundColor = '#ffdfe1'
              property.color = '#f12b37'
            } else if (data === 'OOS' || data === 'OOO') {
              property.backgroundColor = '#cdcccc'
              property.color = '#575757'
            } else {
              // clean
              property.backgroundColor = '#ffecd5'
              property.color = '#ea7e00'
            }
            return property
          }
        },
        {
          headerName: this.$t('grid.column.diff'),
          field: 'diff'
        },
        {
          headerName: this.$t('grid.column.bookingRoomStatus'),
          field: 'booking_room_status'
        }
      ],
      rows: []
    }
  },
  // watch: {
  //   'searchParams.room_start'(value) {
  //     this.searchParams.room_end = value
  //   },
  //   'searchParams.drif'() {
  //     if (this.searchParams.drif) {
  //       this.searchParams.diff = ['Sleep', 'Skip', 'People']
  //     } else {
  //       this.searchParams.diff = []
  //     }
  //   }
  // },
  async mounted() {
    // check author
    this.checkAuthorRoomChecked = checkAuthorized('SCHEDULE_HOUSEKEEPING_READY')
    this.checkAuthorChangeRoomStt1 = checkAuthorized('CHANGE_STATUS_ROOM_1')
    this.checkAuthorChangeRoomStt2 = checkAuthorized('CHANGE_STATUS_ROOM_2')
    //
  },
  methods: {
    addHkStatus() {},
    onRowSelected() {
      const gridApi = this.$refs.agGrid.gridApi
      this.selectedRows = gridApi.getSelectedRows()
      this.isOOORoom = false
      this.selectedRows.forEach(item => {
        if (item.room_status === 'OOO' || item.room_status === 'OOS') {
          this.isOOORoom = true
        }
      })
    },
    onSearch(params) {
      this.searchParams = params
      this.attachData()
    },
    onReset(params) {
      this.searchParams = params
      this.attachData()
    },
    async changeRoomCondition(roomStatus = null, roomType = null) {
      const selectedIds = this.selectedRows.map(item => item.room_id) || []
      const params = {
        room_ids: selectedIds,
        room_status: roomStatus,
        room_type: roomType
      }
      await changeStatusHouseKeepingApi(params)
        .then(async res => {
          const message = res.message
          await this.attachData()
          // this.dialogFormVisible = false
          this.$message({
            type: 'success',
            message: this.$t(`successMsg.${message}`)
          })
        })
        .catch(error => {
          const message = error.response?.data?.message || 'default'
          this.$message({
            type: 'error',
            message: this.$t(`errorMsg.${message}`)
          })
        })
    },
    onDelete() {
      this.$vxConfirm('Bạn có chắc chắn muốn xóa yêu cầu không', () => {})
    },
    async attachData() {
      const data = await getListHouseKeepingApi(this.searchParams)
      this.rows = data.data
      this.selectedRows = []
    }
  }
}
</script>

<style lang="scss"></style>
